import {
  HEADER_SIO_INIT,
  HEADER_SIO_INIT_SUCCESS,
} from "./actionTypes"


export const headerSioInit = data => ({
  type: HEADER_SIO_INIT,
  payload: data
});

export const headerSioInitSuccess = data => ({
  type: HEADER_SIO_INIT_SUCCESS,
  payload: data
});
